module.exports = __webpack_public_path__ + "img/banner-small-mini.39826894.png";